/**
 * Pure string helpers ported from the legacy Angular `HelperService`.
 * Behaviour is kept identical so analytics labels remain unchanged.
 */

export function replaceAccents(str: string): string {
  return str.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
}

export function normalizeString(str: string): string {
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/([^\w]+|\s+)/g, '-');
}

export function pascalCase(str: string): string {
  return str
    .split(':')
    .map((part) => {
      const noAccents = replaceAccents(part);
      return (
        noAccents.charAt(0).toUpperCase() +
        noAccents
          .replace(/\s(.)/g, (match) => match.toUpperCase())
          .replace(/\s/g, '')
          .replace(/^(.)/, (first) => first.toLowerCase())
          .slice(1)
      );
    })
    .join(':');
}

export function skewerCase(str: string): string {
  const result = str
    .split(':')
    .map((item) => {
      if (item === 'SocialLink') {
        return 'social-link';
      }
      return item.toLowerCase().replace(/\s/g, '-');
    })
    .join(':');
  return replaceAccents(result);
}
